const home = {
  title: "Home",
  hello: `Hello {{name}}`,
  greetings: `The {{applicationHeading}} is a Canadian EY application that has been developed for the Canadian Restructuring Practice to manage complex engagements involving claims. The application can be used on traditional insolvency engagements including CCAA, Receiverships* and Bankruptcies*, as well as non-insolvency claims processes such as class actions and other court sanctioned claims processes. For more information on the use of this application, contact <Email />. For learning materials, please visit <LearningMaterialsLink>here</LearningMaterialsLink>.`,
  learningMaterials: "Learning Materials",
  quickActions: {
    quickActionHeading: "Quick Actions",
    quickActionsList: {
      newCaseSetup: {
        header: "New Case Setup",
        body: "Users who have been granted a case manager role can create a new case in the {{applicationHeading}} application here.",
        footer: "Set up a Case",
      },
      applicationAdminSettings: {
        header: "Application Admin Settings",
        body: "Users who have been granted system administrator role can modify the administrative settings for the application here.",
        footer: "Manage Users",
      },
      formConfiguration: {
        header: "Portal Form Configuration",
        body: "Users who have been granted case manager role can create and modify external forms on a case basis here.",
        footer: "Create a Portal Form",
      },
    },
  },
  tableTile: "All Cases",
  tableDescription:
    "The following is a list of cases to which you have been granted access.",
  columnList: {
    caseName: "Case Name",
    caseShortName: "Case Short Name",
    caseStatus: "Status",
    caseLastUpdateOn: "Last Updated On",
  },
  rowList: {
    statusOpen: "Open",
    statusClose: "Close",
  },
};

export default home;
